<template>
    <div class="con">
        <div class="banner">
            <img src="../assets/pro/ban.png" alt="">
        </div>
        <div class="main">
            <div class="text wow fadeInUp">
                <div @click="goto(0)" style="cursor: pointer">
                    <span>Home</span>
                    <span>></span>
                </div>
                <div @click="goto(1)" style="cursor: pointer">
                    <span>Products</span>
                    <span>> </span>
                </div>
                <div v-for="(item,index) in navList2" :key="index">
                    <span @click="gotoPro(item.id)">{{item.title}}</span>
                    <span v-if="index!==navList2.length-1">> </span>
                </div>
                <!--                <div v-for="(item,index) in tList" :key="index">-->
                <!--                    <span :class="{'red':index===tList.length-1}">{{item.name}}</span>-->
                <!--&lt;!&ndash;                    <span v-if="index!==tList.length-1 && item.id!==''">></span>&ndash;&gt;-->
                <!--                </div>-->
            </div>


            <!--            <div class="search wow fadeInUp">-->
            <!--                <input type="text" placeholder="Search for the product you want to know... ..." v-model="proName">-->
            <!--                <i class="iconfont icon-sousuo" @click="search"></i>-->
            <!--            </div>-->
            <!--            <div class="table wow fadeInUp">-->
            <!--                <div class="onea">-->
            <!--                    <span>Product Categories</span>-->
            <!--                    <span></span>-->
            <!--                    <span></span>-->
            <!--                    <span></span>-->
            <!--                </div>-->
            <!--                <div class="mainCon">-->
            <!--                    <div class="one">-->
            <!--                        <span v-for="(item,index) in proOne" :key="item.ID" :class="{'oneStyle':index===num1}"  @click="funOne(index,item.ID,item.CALLED)">{{item.CALLED}}</span>-->
            <!--                    </div>-->
            <!--                    <div class="two">-->
            <!--                        <span v-for="(item,index) in proTwo" :key="item.ID" :class="{'oneStyle':index===num2}"  @click="funTwo(index,item.ID,item.CALLED)">{{item.CALLED}}</span>-->
            <!--                    </div>-->
            <!--                    <div class="three">-->
            <!--                        <span v-for="(item,index) in proThree" :key="item.ID" :class="{'oneStyle':index===num3}"  @click="funThree(index,item.ID,item.CALLED)">{{item.CALLED}}</span>-->
            <!--                    </div>-->
            <!--                    <div class="four">-->
            <!--                        <span v-for="(item,index) in proFour" :key="item.ID" :class="{'oneStyle':index===num4}" @click="funFour(index,item.ID,item.CALLED)">{{item.CALLED}}</span>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </div>-->
            <!--            <div class="text wow fadeInUp">-->
            <!--                <div @click="goto(0)" style="cursor: pointer">-->
            <!--                    <span>Home</span>-->
            <!--                    <span>></span>-->
            <!--                </div>-->
            <!--                <div @click="goto(1)" style="cursor: pointer">-->
            <!--                    <span>Products</span>-->
            <!--                    <span></span>-->
            <!--                </div>-->
            <!--             <div v-for="(item,index) in tList" :key="index">-->
            <!--                 <span :class="{'red':index===tList.length-1}">{{item.name}}</span>-->
            <!--&lt;!&ndash;                 <span v-if="index!==tList.length-1">></span>&ndash;&gt;-->
            <!--             </div>-->
            <!--            </div>-->
            <div class="list wow fadeInUp">
                <div class="oItem" v-for="(item,index) in proList" :key="index">
                    <div class="left" @click="gotoInfo(item.ID)">
                        <img :src="`https://www.cabling-vivanco.com/upload/${item.SMALLPIC}`" alt="">
                    </div>
                    <div class="right">
                        <p>{{item.PRONAME}}</p>
                        <p>{{item.PROTEXT}}</p>
                        <div>
                            <span @click="gotoInfo(item.ID)">View More</span>
                            <a :href="`https://www.cabling-vivanco.com/upload/${item.HREF}`" target="_blank"
                               :download="item.PRONAME">
                                <i class="el-icon-document">

                                </i>
                                Product Data Sheet
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page">
            <el-pagination
                    background
                    layout="prev, pager, next"
                    :page-count="totalPage"
                    @current-change="handleCurrentChange"
            >
            </el-pagination>
        </div>
        <!--        <div class="btn wow fadeInUp" @click="showMore" v-if="showBtn">-->
        <!--              <btn-Component></btn-Component>-->
        <!--        </div>-->
        <foot-Component></foot-Component>
    </div>
</template>

<script>
    import btnComponent from '../components/btn'
    import footComponent from '../components/foot'
    import {getProductstypeUrl2, getProductsUrl, getOnePro, getClassName} from '../util/lang'

    export default {
        name: "pro",
        data() {
            return {
                navList2: [],
                showBtn: true,
                proName: '',
                page: 0,
                totalPage: 0,
                pid: '',
                num1: '',
                num2: '',
                num3: '',
                num4: '',
                tList: [{id: '', name: ''}],
                proOne: [],
                proTwo: [],
                proThree: [],
                proFour: [],
                proList: [],
            }
        },
        components: {footComponent},
        mounted() {
            localStorage.removeItem('arr')
            this.getPro()
            this.getNid()
            if (this.getNid() !== undefined) {
                this.getProList(parseInt(this.getNid()))
                this.getClass(parseInt(this.getNid()))
            } else {
                this.getProList('42')
            }
        },
        methods: {
            gotoPro(id) {
                const link = `/pro.html?id=${id}`
                window.open(link, '_self')
            },
            getClass(id) {
                const url = `${getClassName('zh-CN', id)}`
                this.$axios.get(url).then(res => {
                    this.navList2 = res.data
                    console.log(res.data)
                })
            },
            search() {
                if (this.proName === '') {
                    this.$notify({
                        title: 'Prompt',
                        message: 'Please enter the name of the product to search for',
                        offset: 100
                    });
                } else {
                    const url = `${getOnePro('zh-CN', '42', this.proName, 10000, 1)}`
                    this.$axios.get(url).then(res => {
                        this.proList = res.data.proarr
                        this.proName = ''
                        this.showBtn = false
                    })
                }

            },
            getNid() {
                return window.location.search.replace('?', '').split('=')[1]
            },
            handleCurrentChange(val) {
                if (val <= this.totalPage) {
                    this.$nextTick(() => {
                        const url = `${getProductsUrl('zh-CN', this.pid, 6, val)}`
                        this.$axios.get(url).then(res => {
                            // console.log(res.data.newsArr)
                            this.proList = res.data.proarr
                        })

                    })
                } else {
                    this.$notify({
                        title: 'Prompt',
                        message: 'Already Loaded',
                        offset: 100
                    });
                }
            },
            // showMore(){
            //     if(this.page<=this.totalPage){
            //         this.$nextTick(()=>{
            //             const url = `${getProductsUrl('zh-CN',this.pid,6,this.page++)}`
            //             this.$axios.get(url).then(res => {
            //                 this.proList=this.proList.concat(res.data.proarr)
            //                 // console.log(res.data.proarr)
            //             })
            //         })
            //     }else{
            //         this.$notify({
            //             title: 'Prompt',
            //             message: 'Already Loaded',
            //             offset: 100
            //         });
            //     }
            // },
            getPro() {
                this.$nextTick(() => {
                    const url = `${getProductstypeUrl2('zh-CN', '42')}`
                    this.$axios.get(url).then(res => {
                        this.proOne = res.data
                    })
                })
            },
            gotoInfo(id) {
                localStorage.setItem('arr', JSON.stringify(this.tList))
                const link = `/proInfo.html?pid=${id}`
                window.open(link)
            },
            addText(obj) {
                for (let i = 0; i < this.tList.length; i += 1) {
                    if (this.tList[i].id === obj.id) {
                        this.tList[i] = {}
                    } else if (this.tList[i].id > obj.id) {
                        this.tList[i] = {}
                    }
                }
                this.tList.push(obj)
            },
            funOne(index, id, text) {
                this.num1 = index
                this.num2 = ''
                this.proTwo = []
                this.proThree = []
                this.proFour = []
                this.showBtn = true
                this.addText({id: 1, name: '>' + text})
                const url = `${getProductstypeUrl2('zh-CN', id)}`
                this.$axios.get(url).then(res => {
                    if (res.data.length > 0) {
                        this.proTwo = res.data
                        this.proList = []
                    } else {
                        this.getProList(id)
                    }
                })
            },
            getProList(id) {
                this.pid = id
                this.page = 2
                const url2 = `${getProductsUrl('zh-CN', id, 6, 1)}`
                this.$axios.get(url2).then(res => {
                    this.proList = res.data.proarr
                    this.totalPage = res.data.pagershow.totalPagers
                })
            },
            funTwo(index, id, text) {
                this.num2 = index
                this.num3 = ''
                this.addText({id: 2, name: '>' + text})
                this.proThree = []
                this.proFour = []
                this.showBtn = true
                const url = `${getProductstypeUrl2('zh-CN', id)}`
                this.$axios.get(url).then(res => {
                    if (res.data.length > 0) {
                        this.proThree = res.data
                        this.proList = []
                    } else {
                        this.getProList(id)
                    }
                })
            },
            funThree(index, id, text) {
                this.num3 = index
                this.num4 = ''
                this.addText({id: 3, name: '>' + text})
                this.proFour = []
                this.showBtn = true
                const url = `${getProductstypeUrl2('zh-CN', id)}`
                this.$axios.get(url).then(res => {
                    if (res.data.length > 0) {
                        this.proFour = res.data
                        this.proList = []
                    } else {
                        this.getProList(id)
                    }
                })
            },
            funFour(index, id, text) {
                this.num4 = index
                this.showBtn = true
                this.addText({id: 4, name: '>' + text})
                this.getProList(id)
            },
            goto(n) {
                const link = `/index.html`
                const link2 = `/pro.html`
                if (n === 0) {
                    window.open(link, '_self')
                } else {
                    window.open(link2, '_self')
                }

            }
        }
    }
</script>

<style lang="scss" scoped>
    .con {
        width: 100%;
        animation: yd 2s forwards linear;
        @keyframes yd {
            from {
                transform: translateX(20px);
            }
            to {
                transform: translateX(0);
            }
        }

        .banner {
            width: 100%;

            img {
                width: 100%;
                /*height: 490px;*/
                object-fit: cover;
                display: block;
            }
        }

        .main {
            width: 1400px;
            margin: 60px auto;

            .search {
                width: 100%;
                position: relative;

                input {
                    width: 60%;
                    background: none;
                    outline: none;
                    height: 40px;
                    border: none;
                    text-indent: 20px;
                    border-bottom: 1px solid #DEDEDE;
                    font-style: italic;
                    font-family: "Fira Code Medium";
                    color: #ACACAC;
                    margin-left: 20%;
                }

                i {
                    color: #A5A2A2;
                    font-size: 28px;
                    position: absolute;
                    right: 22%;
                    top: 5px;
                    cursor: pointer;
                }
            }

            .table {
                width: 100%;
                margin: 60px auto;

                .onea {
                    width: 100%;
                    display: flex;
                    flex-direction: row;

                    span {
                        display: inline-block;
                        width: 25%;
                        text-align: center;
                        height: 50px;
                        line-height: 50px;
                        color: white;
                        font-family: "Fira Code Medium";
                        font-weight: lighter;
                        text-transform: uppercase;
                    }

                    span:nth-child(1) {
                        background-color: #0A0A0A;
                    }

                    span:nth-child(2) {
                        background-color: #242424;
                    }

                    span:nth-child(3) {
                        background-color: #2E2E2E;
                    }

                    span:nth-child(4) {
                        background-color: #3D3D3D;
                    }
                }

                .mainCon {
                    width: 100%;
                    display: flex;
                    flex-direction: row;

                    div {
                        width: 25%;
                        padding: 30px 20px;
                        border-bottom: 1px solid #DEDEDE;
                        display: flex;
                        flex-direction: column;
                        text-indent: 5%;
                        padding-bottom: 80px;

                        span {
                            transition: all 1s;
                            cursor: pointer;
                            line-height: 35px;
                            font-family: "Fira Code Medium";
                            font-weight: lighter;
                            position: relative;
                        }

                        span::before {
                            content: '';
                            position: absolute;
                            border: 0.3rem solid #d8d8d8;
                            border-color: #578300 transparent transparent;
                            width: 0;
                            height: 0;
                            transform: rotate(-90deg);
                            top: 0.7rem;
                            right: 0;
                            opacity: 0;
                            transition: all 1s;
                        }

                        span:hover {
                            color: #578300;
                        }

                        span:hover::before {
                            opacity: 1;
                        }

                        .oneStyle {
                            color: #578300;
                        }

                        .oneStyle::before {
                            opacity: 1;
                            transform: rotate(0);
                        }
                    }

                    .one {
                        border-left: 1px solid #DEDEDE;
                        border-right: 1px solid #DEDEDE;
                    }

                    .two, .three, .four {
                        border-right: 1px solid #DEDEDE;
                    }
                }

                margin-bottom: 30px;
            }

            .text {
                width: 100%;
                border-bottom: 1px solid #DEDEDE;
                display: flex;
                flex-direction: row;
                padding-bottom: 20px;
                color: #787878;
                flex-wrap: wrap;
                font-family: "Fira Code Medium";

                div {
                    letter-spacing: 1px;
                    line-height: 30px;
                    cursor: pointer;

                    span {
                        font-size: 14px;
                        font-family: "Fira Code Medium";
                        font-weight: lighter;
                    }

                    .red {
                        color: #91C131;
                    }
                }
            }

            .list {
                width: 100%;
                display: flex;
                flex-direction: column;

                .oItem {
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    border-bottom: 1px solid #DEDEDE;
                    margin-top: 10px;
                    padding-bottom: 10px;
                    cursor: pointer;

                    .left {
                        width: 30%;
                        /*border: 1px solid #DEDEDE;*/
                        text-align: center;
                        /*height:180px;*/
                        padding: 10px 0;

                        img {
                            transition: all 1s;
                            width: 90%;
                            object-fit: cover;
                            margin-left: 5%;
                        }
                    }

                    .right {
                        margin-left: 5%;
                        width: 60%;

                        p:nth-child(1) {
                            font-family: "Fira Code Medium";
                            font-weight: lighter;
                            font-size: 18px;
                            margin-top: 10px;
                            transition: all 1s;
                        }

                        p:nth-child(2) {
                            color: #919191;
                            line-height: 30px;
                            font-family: "Fira Code Medium";
                            font-weight: lighter;
                            height: 60px;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                            transition: all 1s;
                            margin-top: 10px;
                        }

                        div {
                            width: 100%;
                            display: flex;
                            flex-direction: row;
                            margin-top: 10px;

                            a {
                                display: flex;
                                flex-direction: row;
                                border: 1px solid #DEDEDE;
                                font-size: 15px;
                                align-items: center;
                                width: 200px;
                                padding: 5px 20px;
                                margin-left: 20px;

                                i {
                                    font-size: 20px;
                                    transition: all 1s;
                                    margin-right: 10px;
                                }

                                &:hover {
                                    background-color: #91c131;
                                    color: white;

                                    i {
                                        color: white;
                                    }
                                }
                            }

                            span, a {
                                font-family: "Fira Code Medium";
                                font-weight: lighter;
                                transition: all 1s;
                            }

                            span {
                                background-color: #91c131;
                                color: white;
                                padding: 5px 30px;
                                border-radius: 5px;

                                &:hover {
                                    color: white;
                                }
                            }
                        }
                    }
                }

                .oItem:hover {
                    .left {
                        img {
                            transform: scale(1.05);
                        }
                    }

                    .right {
                        p {
                            color: #91C131;
                        }
                    }
                }
            }
        }

        .btn {
            width: 100%;
            text-align: center;
            margin: 60px auto;
            padding-bottom: 60px;
        }
        .page{
            text-align: center;
            margin: 30px auto;
        }

        @media screen and (max-width: 1399px) and (min-width: 1000px) {
            .main {
                width: 90%;
            }
        }
        @media screen and (max-width: 999px) {
            .banner {
                img {
                    height: 300px;
                }
            }
            .main {
                width: 90%;

                .search {
                    input {
                        width: 80%;
                        margin-left: 8%;
                    }

                    i {
                        right: auto;
                    }
                }

                .table {
                    .onea {
                        font-size: 14px;
                    }

                    .mainCon {
                        div {
                            padding: 30px 5px;

                            span {
                                font-size: 12px;
                            }
                        }
                    }
                }

                .list {
                    .oItem {
                        flex-direction: column;
                        margin-top: 30px;
                        .left, .right {
                            width: 100%;
                            margin-left: 0;
                        }
                        .right {
                            p:nth-child(1) {
                                font-size: 18px;
                                line-height: 30px;
                            }

                            p:nth-child(2) {
                                margin: 10px 0;
                            }

                            div {
                                a, span {
                                    padding: 5px 0;
                                    text-align: center;
                                }

                                a {
                                    width: 65%;
                                    justify-content: center;

                                    i {
                                        margin-right: 5px;
                                    }
                                }

                                span {
                                    width: 35%;
                                    border-radius: 0;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
